import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { yupResolver } from '@hookform/resolvers';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { RequiredString } from 'helpers/yupHelper';
import { getCompanies } from 'services/rest/SuperAdmin/Company/getCompanies';
import { useHistory } from 'react-router-dom';
import { ErrorAlert } from 'components/Alert';
import {
  AgentData,
  createAgent
} from 'services/rest/SuperAdmin/Agents/createAgent';
import CreateAgentForm from './CreateAgentForm';

interface Option {
  value: number; // o string si tus IDs son strings
  label: string;
}

const CreateAgent: React.FC = () => {
  const { t } = useTranslation(['super_admin_agent', 'validations']);
  const userSchema = yup.object().shape({
    name: RequiredString().max(70, t('validations:length_error', { max: 70 })),
    lastName: RequiredString().max(
      70,
      t('validations:length_error', { max: 70 })
    ),
    email: RequiredString().max(
      100,
      t('validations:length_error', { max: 100 })
    )
  });

  const {
    register,
    control,
    handleSubmit,
    setValue,
    errors,
    setError: setErrors
  } = useForm({
    resolver: yupResolver(userSchema)
  });
  const { currentUser } = useSelector(selectUser);
  const [companies, setcompanies] = useState<any | null>(null);
  const [selectedCompanies, setSelectedCompanies] = useState<Option[]>([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState<string>('');
  const history = useHistory();

  const onSubmit = async (agentData: AgentData) => {
    setLoader(true);
    const { data, errors } = await createAgent(
      currentUser?.token,
      agentData,
      selectedCompanies
    );
    if (data) {
      setLoader(false);
      if (data?.errors) {
        setError(data.errors?.data);
      } else {
        history.push('/agents', t('super_admin_agent:create_success'));
      }
    }
    if (errors) {
      setError(errors?.data);
      setLoader(false);
    }
  };

  const getData = async () => {
    const { data } = await getCompanies(currentUser?.token, 500, 1);
    setcompanies(data);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {error && (
        <ErrorAlert
          text={error}
          allowClose={true}
          onClose={() => setError('')}
        />
      )}
      <CreateAgentForm
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        errors={errors}
        setErrors={setErrors}
        setValue={setValue}
        control={control}
        loader={loader}
        companies={companies}
        selectedCompanies={selectedCompanies}
        setSelectedCompanies={setSelectedCompanies}
      />
    </>
  );
};

export default CreateAgent;
